import React from 'react'
import './MainAdmin.css'
import { useState, useEffect } from 'react'
import fetchData from '../../function/fetchData'
import LoggedAdmin from './LoggedAdmin'

const MainAdmin = ({server, cetral = false}) => {
  const [token, setToken] = useState(null)
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")



    // Má data v localstorage?
    useEffect( () => {
      const data = localStorage.getItem('driverToken');
      if(data) {
        setToken(data)
      }
    }, [])

  const onHandle = () => {
    // Pošle přihlašovací data na serve a čeká na TOKEN
    const adresOfServer = server + "/api2/forDriver.php";

    const whatToSend = {
        action: "GET_TOKEN",
        email : email,
        password: password,
    }
    fetchData(adresOfServer, whatToSend)
    .then((res) => {
   
        if(res.info === "OK"){
            // Nastaví token
            setToken(res.driverToken)
            // Uloží token
            localStorage.setItem('driverToken', res.driverToken);
          
        } else if(res.info === "wrong acces"){
            alert("Zadali jste špatné jméno, nebo heslo")
        }
    })
}  


   if(!token){
        return (
            <div className='driverHomeContainer'>
                <div className="driverHomeContant">
                    <label>Přihlaště se</label>
                    <input type="text" placeholder='Email' className='password' value={email} onChange={(e)=>setEmail(e.target.value)}/>
                    <input type="text" placeholder='Vaše heslo' className='password' value={password} onChange={(e)=>setPassword(e.target.value)}/>
                    <button className='button' onClick={onHandle}>Přihlásit se</button>
                  </div>
            </div>
          )
    } else {
        return ( 
            <LoggedAdmin server={server} token={token} cetral={cetral}/>
        )
    } 
}

export default MainAdmin
